import { Editor, Element, Transforms } from 'slate'
import { useSlate } from 'slate-react'
import React from 'react'

import EditorIcon from '../EditorIcon'

const isActive = (editor, name) => {
  const { selection } = editor
  if (!selection) return false

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: n => !Editor.isEditor(n) && Element.isElement(n) && n.type === name
    })
  )

  return !!match
}

const toggle = (editor, name) => {
  const active = isActive(editor, name)
  Transforms.setNodes(editor, {
    type: !active ? name : 'paragraph'
  })
}

const ToggleIcon = ({ icon, name, ...props }) => {
  const editor = useSlate()
  const active = isActive(editor, name)

  return <EditorIcon onClick={() => toggle(editor, name)} icon={icon} active={active} {...props} />
}

const BlockPlugin = {
  isActive,
  toggle,
  ToggleIcon
}

export default BlockPlugin
